import styled from 'styled-components'

const PageonLoadWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: pink;

  #root-loading {
    display: block;
    position: fixed;
    z-index: 100000;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: initial;
  }
  @keyframes root-loading-ball {
    0% {
      transform: translate(-50%, -50%) scale(0.5);
    }

    100% {
      opacity: 0;
      transform: translate(-50%, -50%) scale(1);
    }
  }
  @keyframes root-loading-text {
    0% {
      opacity: 0.1;
    }

    50% {
      opacity: 1;
    }

    100% {
      opacity: 0.1;
    }
  }
  #root-loading::before {
    position: absolute;
    left: 50%;
    top: 50%;
    content: '.';
    font-size: 0;
    width: 90px;
    height: 90px;
    background: #ddd;
    border-radius: 90px;
    transform: translate(-50%, -50%) scale(0.5);
    -ms-transform: translate(-50%, -50%) scale(0.5);
    animation: root-loading-ball 1s infinite;
  }
  #root-loading::after {
    font-size: 12px;
    color: #888;
    position: absolute;
    content: 'Loading';
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    animation: root-loading-text 1s infinite;
  }
`
export default PageonLoadWrapper
